import { JOBS_URL } from '@/utils/constants'

const JOBS = () => JOBS_URL
const JOB_BY_ID = (id: string) => `${JOBS_URL}/${id}`
const JOB_CLOSE = (id: string) => `${JOBS_URL}/${id}/close`
const JOBS_NOTIFICATIONS = () => `tasks/activities`
const JOBS_TASKS = () => `${JOBS_URL}/tasks`
const JOB_TASKS_BY_ID = (jobId: string) => `${JOBS_URL}/${jobId}/tasks/`
export default {
  JOBS,
  JOB_BY_ID,
  JOB_CLOSE,
  JOBS_NOTIFICATIONS,
  JOBS_TASKS,
  JOB_TASKS_BY_ID
}
